<template>
  <b-button
    variant="outline-primary m-1 btn-sm position-bottom"
    class="show-time-btn"
    @click="showClientTime"
    >Show Time</b-button
  >
</template>

<script>
export default {
  name: "ShowTimeButton",
  props: {
    clientId: {
      required: true,
      type: Number
    }
  },
  methods: {
    /**
     * Navigates to user timelogs for this client
     */
    showClientTime() {
      this.$router.push({
        name: "UserTimelogs",
        params: { clientId: this.clientId }
      })
    }
  }
}
</script>

<style scoped></style>
